var map = {
	"./about": [
		14167,
		533,
		612,
		443
	],
	"./about.js": [
		14167,
		533,
		612,
		443
	],
	"./catering": [
		17242,
		533,
		34,
		30,
		242,
		566
	],
	"./catering.js": [
		17242,
		533,
		34,
		30,
		242,
		566
	],
	"./contact": [
		32788,
		631
	],
	"./contact.js": [
		32788,
		631
	],
	"./default": [
		87584,
		913
	],
	"./default.js": [
		87584,
		913
	],
	"./gallery": [
		5675,
		612,
		121
	],
	"./gallery.js": [
		5675,
		612,
		121
	],
	"./home": [
		63500,
		177
	],
	"./home.js": [
		63500,
		177
	],
	"./landing": [
		24255,
		533,
		34,
		612,
		30,
		922,
		242,
		255,
		443,
		246
	],
	"./landing.js": [
		24255,
		533,
		34,
		612,
		30,
		922,
		242,
		255,
		443,
		246
	],
	"./menus": [
		86922,
		922,
		316
	],
	"./menus.js": [
		86922,
		922,
		316
	],
	"./press": [
		16773,
		342
	],
	"./press.js": [
		16773,
		342
	],
	"./private_events": [
		81350,
		533,
		34,
		612,
		30,
		255
	],
	"./private_events.js": [
		81350,
		533,
		34,
		612,
		30,
		255
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 91559;
module.exports = webpackAsyncContext;